import { lazy } from "react";
import { clearStudioView, setStudioView } from "../workspace/studio-views";
import type { IrisReviewProps } from "./IrisReview";
const IrisReview = lazy(() => import("./IrisReview").then((module) => ({ default: module.IrisReview })));
const IrisReviewButton = lazy(() => import("./IrisReview").then((module) => ({ default: module.IrisReviewButton })));

/** The review sheet over the storyboard; null closes it. */
export function mountIrisReview(projectId: string, props: IrisReviewProps | null) {
  if (!props) return clearStudioView("iris-review");
  setStudioView("iris-review", `iris-review:${projectId}`, <IrisReview {...props} />);
}

/** The Checks tab's "Review with Iris (n)"; nothing when there is nothing to review and nothing Iris approved. */
export function mountIrisReviewEntry(projectId: string, count: number, onOpen: () => void, herself = 0) {
  if (count <= 0 && herself <= 0) return clearStudioView("iris-review-entry");
  setStudioView("iris-review-entry", `iris-review-entry:${projectId}`, <IrisReviewButton count={count} herself={herself} onOpen={onOpen} />);
}
